import permission from "@/http/requests/permission"

export default {
  fetch({ commit }) {
    return new Promise((resolve, reject) => {
      permission.fetch().then(response => {
        commit('SET_PERMISSIONS', response.data.data.permissions)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
